import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Compass, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Siden blev ikke fundet (404) | John Calmar</title>
        <meta name="description" content="Siden du leder efter, findes desværre ikke. Gå tilbage til forsiden for at udforske clairvoyance, hypnose og meget mere hos John Calmar." />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="Siden blev ikke fundet (404) | John Calmar" />
        <meta property="og:description" content="Siden du leder efter, findes desværre ikke hos John Calmar." />
      </Helmet>

      <div className="min-h-[70vh] flex flex-col items-center justify-center px-6 text-center relative overflow-hidden">
        {/* Ambient background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-brand-500/5 rounded-full blur-3xl pointer-events-none" />

        <div className="relative z-10 space-y-6 max-w-md">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-500/10 text-brand-400 mb-2 animate-bounce">
            <Compass className="w-8 h-8" />
          </div>

          <h1 className="text-7xl sm:text-8xl font-light text-brand-300 tracking-tight">
            404
          </h1>

          <h2 className="text-2xl sm:text-3xl font-display font-light text-white">
            Siden blev ikke fundet
          </h2>

          <p className="text-neutral-400 font-light leading-relaxed">
            Siden du leder efter, findes desværre ikke eller er blevet flyttet. Lad os hjælpe dig med at finde vejen tilbage.
          </p>

          <div className="pt-6">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-brand-500 hover:bg-brand-600 text-neutral-950 font-semibold rounded-xl transition-all duration-200 shadow-lg shadow-brand-500/10 cursor-pointer"
            >
              <ArrowLeft className="w-4 h-4" />
              Gå til forsiden
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
